import React from 'react'
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native'

interface Props {
  visible: boolean
  days: Array<{ dayNumber: number; date: string }>
  onClose: () => void
  onSelect: (date: string, dayNumber: number) => void
}

const DatePickerModal: React.FC<Props> = ({ visible, days, onClose, onSelect }) => {
  if (!visible) return null
  return (
    <View style={styles.overlay as any} onClick={(e: any) => { if (e && e.target && e.target === e.currentTarget) onClose(); }}>
      <View style={styles.sheet as any} onClick={(e: any) => e.stopPropagation()}>
        <Text style={styles.title}>选择日期</Text>
        <View style={{ marginTop: 12 }}>
          {days && days.length ? (
            <View style={styles.grid}>
              {days.map(d => (
                <TouchableOpacity key={d.date} style={styles.dayTile} onPress={() => onSelect(d.date, d.dayNumber)}>
                  <Text style={styles.tileDay}>第{d.dayNumber}天</Text>
                  <Text style={styles.tileDate}>{d.date}</Text>
                </TouchableOpacity>
              ))}
            </View>
          ) : (
            <View style={{ padding: 12 }}><Text>该行程暂无日期</Text></View>
          )}
        </View>
        <View style={{ marginTop: 12, flexDirection: 'row', justifyContent: 'flex-end' }}>
          <TouchableOpacity style={styles.cancelBtn} onPress={onClose}><Text>取消</Text></TouchableOpacity>
        </View>
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  overlay: { position: 'fixed', left: 0, right: 0, top: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.36)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10000 },
  sheet: { width: 360, maxWidth: '92%', backgroundColor: '#fff', borderRadius: 12, padding: 12 },
  title: { fontSize: 16, fontWeight: '700' },
  grid: { flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-between' },
  dayTile: { width: '30%', aspectRatio: 1, backgroundColor: '#fff', borderRadius: 8, alignItems: 'flex-start', justifyContent: 'center', padding: 10, boxShadow: '0 1px 2px rgba(0,0,0,0.04)', marginBottom: 10 },
  tileDay: { fontWeight: '700', marginBottom: 6 },
  tileDate: { color: '#6B7280', fontSize: 12 },
  cancelBtn: { paddingHorizontal: 12, paddingVertical: 8 }
})

export default DatePickerModal
